<template>
  <div class="interactive" :style="{ height: height + 'px' }">
    <div :style="{ height: ( height - 20 ) + 'px' }" class="content">
      <div id="dialogue_box" class="rolling">
        <li v-for="(item,index) in messageList" :key="index">
          <!--          <div class="img fl"><img src="../../../assets/portrait.png" width="40" height="40" alt=""></div>-->
          <div class="Txt fl">
            <div class="name">
              <span class="fl">{{item.username}}</span>
            </div>
            <div class="p">{{item.msg}}</div>
          </div>
        </li>
      </div>
      <el-input
        type="textarea"
        class="textarea"
        placeholder="请输入内容"
        v-model="textarea">
      </el-input>
      <div @click="sure" class="sure fr">确定</div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      height: {
        type: Number,
        default: 3.5
      },
      chatRoom: {
        type: Object
      }
    },
    data () {
      return {
        textarea: '',
        messageList: []
      }
    },
    created () {
      this.MessagePush()
    },
    updated: function () {
      this.$nextTick(function () {
        var div = document.getElementById('dialogue_box')
        div.scrollTop = div.scrollHeight
      })
    },
    methods: {
      sure () {
        DWLive.sendPublicChatMsg(this.textarea)
        this.textarea = ''
        this.MessagePush()
      },
      MessagePush () {
        let messageList = this.messageList
        DWLive.onPublicChatMessage = function (e) {
          messageList.push(JSON.parse(e))
        }
        this.messageList = messageList
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .interactive {
    width: 360px;
    margin: 0 auto;
    overflow: hidden;

    .content {
      margin: 20px auto 0;

      .textarea {
        height: 20%;
        margin-top: 10%;

        textarea {
          height: 100%;

          &:focus {
            border: 1px solid #ff827b;
          }
        }
      }

      .rolling {
        height: 60%;
        overflow-x: hidden;
        overflow-y: scroll;

        &::-webkit-scrollbar {
          display: none;
        }

        li {
          overflow: hidden;
          margin-top: 5px;
          border-bottom: 1px solid #ebebeb;
          padding-bottom: 5px;

          &:first-child {
            margin: 0;
          }

          /*.img {*/
          /*  width: 40px;*/
          /*  height: 40px;*/
          /*}*/

          .Txt {
            width: 310px;

            .name {
              line-height: 20px;
              margin: 10px auto 0;
              width: 100%;
              height: 25px;
              overflow: hidden;

              .fr {
                color: #b3b3b3;
              }
            }

            .p {
              font-size: 14px;
              margin: 5px auto;
              line-height: 20px;
            }
          }
        }
      }

      .sure {
        width: 110px;
        height: 40px;
        background-color: #ff8484;
        text-align: center;
        color: #fff;
        line-height: 40px;
        border-radius: 20px;
        cursor: pointer;
        margin: 20px 0 0 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/videoLayer/interactive/interactive.vue